<template>
    <v-container :class="isMobile? 'pl-0':'pl-2'">
        <v-layout row wrap>
            <v-flex>
                <h3 v-if="triptype!='M'" :style="'color:' + theme.primary.base"><v-icon :style="'color:inherit;'">phone</v-icon> &nbsp;Contact Information & Flight Summary</h3>
                <h3 v-if="triptype=='M'" :style="'color:' + theme.primary.base"><v-icon :style="'color:inherit;'">phone</v-icon> &nbsp;Contact Information</h3>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex>
                <table>
                    <tr>
                        <td>{{name}}</td>
                    </tr>
                    <tr>
                        <td>{{address}}</td>
                    </tr>
                    <tr>
                        <td>{{phone}}</td>
                    </tr>
                    <tr>
                        <td>{{email}}</td>
                    </tr>                                                            
                </table>
            </v-flex>
        </v-layout>
    </v-container>  
</template>

<script>
import Theme from '../../theme';
import Helper from '../helper';

export default {
    props:["contactInfo","trip"],
    created(){
        if (this.contactInfo!=null){
            this.name = this.contactInfo.FullName;
            this.address = this.contactInfo.Address;
            this.phone = this.contactInfo.PhoneNo;
            this.email = this.contactInfo.Email;
        }
        if (this.trip!=null){
            this.triptype=this.trip;
        }
    },
    data(){
        return {
            name:"",
            address:"",
            phone:"",
            email:"",
            theme:Theme,
            triptype:"",
        }
    },
    computed:{
        isMobile(){
            return Helper.display.isMobile(this.$vuetify.breakpoint.name); 
        },
    },
}
</script>

<style>

</style>